import Vue from 'vue';
import PreviewImgList from './previewImgList.vue';

let previewImgListInstance;
const PreviewImgListConstructor = Vue.extend(PreviewImgList);

const initPreviewImgListInstance = () => {
  previewImgListInstance = new PreviewImgListConstructor();
  document.body.appendChild(previewImgListInstance.$mount().$el);
};

export default options => {
  if (!previewImgListInstance) {
    initPreviewImgListInstance();
  }
  Object.assign(previewImgListInstance, options);

  return previewImgListInstance.show(vm => {
    previewImgListInstance = null;
  });
};
